/**
 * Capitalizes the very first letter of a string.
 * 
 * @param {string} str - The input string.
 * @returns {string} The string with its first letter capitalized.
 */
export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  const stringVal = String(str);
  return stringVal.charAt(0).toUpperCase() + stringVal.slice(1);
};
